/**
 * El backend maneja cinco estados de job: PENDING, SENT, IN_PROGRESS, DONE y
 * ERROR. EXPORT_STATUS_ENUM solo declara tres, y los dos que faltan son
 * precisamente los que el worker produce mientras trabaja.
 *
 * Tratar un estado no terminal como final rompe las dos vias de aviso a la vez:
 * el polling deja de seguir el export -solo mira los que siguen en vuelo- y el
 * provider lo marca como procesado, con lo que descarta el DONE real que llega
 * despues. El usuario se queda con el spinner y el archivo ya generado.
 */
const EN_VUELO = ['PENDING', 'SENT', 'IN_PROGRESS'];
const TERMINALES = ['DONE', 'ERROR'];

/** El job sigue vivo: hay que seguir esperandolo. */
export const isInFlight = (status?: string): boolean => EN_VUELO.includes(status ?? '');

/**
 * El job acabo, bien o mal. Un estado desconocido NO es terminal a proposito:
 * ante la duda conviene seguir esperando antes que cerrar el seguimiento.
 */
export const isTerminal = (status?: string): boolean => TERMINALES.includes(status ?? '');
